<template>
  <!--同意文管理 -->
  <div id="AgreementEdit">
    <div id="container">
      <masterNavi v-bind:pageid='"AgreementEdit"'></masterNavi>
      <div class="labelTitle lable">同意文管理</div>
      <div class="labelTitle lable">
        本サイトの利用規約<a style="float:right;" @click="isShowTerms=!isShowTerms"><b-icon v-if="isShowTerms" icon="minus-box" type="is-white"/><b-icon v-if="!isShowTerms" icon="chevron-down-box" type="is-white"/></a>
      </div>
      <div v-if="isShowTerms" class="containtsArea">
        <textarea class="agreementTextArea noresize" v-model="agreement.terms" :disabled="!active.terms"></textarea>
        <b-button class="saveButton is-primary" @click="saveTerms" :disabled="!active.terms">保存</b-button>
        <b-field class="file pdfButton">
          <b-upload v-model="termsPdf" @input="termsUpload" :disabled="!active.terms">
            <a class="button is-primary">
              <span>PDFアップロード</span>
            </a>
          </b-upload>
        </b-field>
      </div>
      <div class="labelTitle lable">
        HST確認事項(医療機関)<a style="float:right;" @click="isShowHst_hospital=!isShowHst_hospital"><b-icon v-if="isShowHst_hospital" icon="minus-box" type="is-white"/><b-icon v-if="!isShowHst_hospital" icon="chevron-down-box" type="is-white"/></a>
      </div>
      <div v-if="isShowHst_hospital" class="containtsArea">
        <textarea class="agreementTextArea noresize" v-model="agreement.hst_hospital" :disabled="!active.hst_hospital"></textarea>
        <b-button class="saveButton is-primary" @click="saveHst_hospital" :disabled="!active.hst_hospital">保存</b-button>
      </div>
      <div class="labelTitle lable">
        HST確認事項(ディーラー)<a style="float:right;" @click="isShowHst_dealer=!isShowHst_dealer"><b-icon v-if="isShowHst_dealer" icon="minus-box" type="is-white"/><b-icon v-if="!isShowHst_dealer" icon="chevron-down-box" type="is-white"/></a>
      </div>
      <div v-if="isShowHst_dealer" class="containtsArea">
        <textarea class="agreementTextArea noresize" v-model="agreement.hst_dealer" :disabled="!active.hst_dealer"></textarea>
        <b-button class="saveButton is-primary" @click="saveHst_dealer" :disabled="!active.hst_dealer">保存</b-button>
      </div>
      <div class="labelTitle lable">
        ホルター心電図配送ｻｰﾋﾞｽ確認事項(医療機関)<a style="float:right;" @click="isShowHolter_hospital=!isShowHolter_hospital"><b-icon v-if="isShowHolter_hospital" icon="minus-box" type="is-white"/><b-icon v-if="!isShowHolter_hospital" icon="chevron-down-box" type="is-white"/></a>
      </div>
      <div v-if="isShowHst_hospital" class="containtsArea">
        <textarea class="agreementTextArea noresize" v-model="agreement.holter_hospital" :disabled="!active.holter_hospital"></textarea>
        <b-button class="saveButton is-primary" @click="saveHolter_hospital" :disabled="!active.holter_hospital">保存</b-button>
      </div>
      <div class="labelTitle lable">
        ホルター心電図配送ｻｰﾋﾞｽ確認事項(ディーラー)<a style="float:right;" @click="isShowHolter_dealer=!isShowHolter_dealer"><b-icon v-if="isShowHolter_dealer" icon="minus-box" type="is-white"/><b-icon v-if="!isShowHolter_dealer" icon="chevron-down-box" type="is-white"/></a>
      </div>
      <div v-if="isShowHolter_dealer" class="containtsArea">
        <textarea class="agreementTextArea noresize" v-model="agreement.holter_dealer" :disabled="!active.holter_dealer"></textarea>
        <b-button class="saveButton is-primary" @click="saveHolter_dealer" :disabled="!active.holter_dealer">保存</b-button>
      </div>
      <div class="labelTitle lable">
        PSG確認事項(医療機関)<a style="float:right;" @click="isShowPsg_hospital=!isShowPsg_hospital"><b-icon v-if="isShowPsg_hospital" icon="minus-box" type="is-white"/><b-icon v-if="!isShowPsg_hospital" icon="chevron-down-box" type="is-white"/></a>
      </div>
      <div v-if="isShowPsg_hospital" class="containtsArea">
        <textarea class="agreementTextArea noresize" v-model="agreement.psg_hospital" :disabled="!active.psg_hospital"></textarea>
        <b-button class="saveButton is-primary" @click="savePsg_hospital" :disabled="!active.psg_hospital">保存</b-button>
      </div>
      <div class="labelTitle lable">
        PSG確認事項(ディーラー)<a style="float:right;" @click="isShowPsg_dealer=!isShowPsg_dealer"><b-icon v-if="isShowPsg_dealer" icon="minus-box" type="is-white"/><b-icon v-if="!isShowPsg_dealer" icon="chevron-down-box" type="is-white"/></a>
      </div>
      <div v-if="isShowPsg_dealer" class="containtsArea">
        <textarea class="agreementTextArea noresize" v-model="agreement.psg_dealer" :disabled="!active.psg_dealer"></textarea>
        <b-button class="saveButton is-primary" @click="savePsg_dealer" :disabled="!active.psg_dealer">保存</b-button>
      </div>
      <div class="labelTitle lable">
        ホルター心電図解析確認事項(医療機関)<a style="float:right;" @click="isShowHolterAnalysis_hospital=!isShowHolterAnalysis_hospital"><b-icon v-if="isShowHolterAnalysis_hospital" icon="minus-box" type="is-white"/><b-icon v-if="!isShowHolterAnalysis_hospital" icon="chevron-down-box" type="is-white"/></a>
      </div>
      <div v-if="isShowHolterAnalysis_hospital" class="containtsArea">
        <textarea class="agreementTextArea noresize" v-model="agreement.holter_analysis_hospital" :disabled="!active.holter_analysis_hospital"></textarea>
        <b-button class="saveButton is-primary" @click="saveHolterAnalysis_hospital" :disabled="!active.holter_analysis_hospital">保存</b-button>
      </div>
      <div class="labelTitle lable">
        ホルター心電図解析確認事項(ディーラー)<a style="float:right;" @click="isShowHolterAnalysis_dealer=!isShowHolterAnalysis_dealer"><b-icon v-if="isShowHolterAnalysis_dealer" icon="minus-box" type="is-white"/><b-icon v-if="!isShowHolterAnalysis_dealer" icon="chevron-down-box" type="is-white"/></a>
      </div>
      <div v-if="isShowHolterAnalysis_dealer" class="containtsArea">
        <textarea class="agreementTextArea noresize" v-model="agreement.holter_analysis_dealer" :disabled="!active.holter_analysis_dealer"></textarea>
        <b-button class="saveButton is-primary" @click="saveHolterAnalysis_dealer" :disabled="!active.holter_analysis_dealer">保存</b-button>
      </div>
      <div class="labelTitle lable">
        企業検診確認事項(企業)<a style="float:right;" @click="isShowKenshin_corp=!isShowKenshin_corp"><b-icon v-if="isShowKenshin_corp" icon="minus-box" type="is-white"/><b-icon v-if="!isShowKenshin_corp" icon="chevron-down-box" type="is-white"/></a>
      </div>
      <div v-if="isShowKenshin_corp" class="containtsArea">
        <textarea class="agreementTextArea noresize" v-model="agreement.kenshin_corp" :disabled="!active.kenshin_corp"></textarea>
        <b-button class="saveButton is-primary" @click="saveKenshin_corp" :disabled="!active.kenshin_corp">保存</b-button>
      </div>
      <div class="labelTitle lable">
        企業検診確認事項(ディーラー)<a style="float:right;" @click="isShowKenshin_dealer=!isShowKenshin_dealer"><b-icon v-if="isShowKenshin_dealer" icon="minus-box" type="is-white"/><b-icon v-if="!isShowKenshin_dealer" icon="chevron-down-box" type="is-white"/></a>
      </div>
      <div v-if="isShowKenshin_dealer" class="containtsArea">
        <textarea class="agreementTextArea noresize" v-model="agreement.kenshin_dealer" :disabled="!active.kenshin_dealer"></textarea>
        <b-button class="saveButton is-primary" @click="saveKenshin_dealer" :disabled="!active.kenshin_dealer">保存</b-button>
      </div>
      <div class="labelTitle lable">
        企業検診確認事項(医療機関)<a style="float:right;" @click="isShowKenshin_hospital=!isShowKenshin_hospital"><b-icon v-if="isShowKenshin_hospital" icon="minus-box" type="is-white"/><b-icon v-if="!isShowKenshin_hospital" icon="chevron-down-box" type="is-white"/></a>
      </div>
      <div v-if="isShowKenshin_hospital" class="containtsArea">
        <textarea class="agreementTextArea noresize" v-model="agreement.kenshin_hospital" :disabled="!active.kenshin_hospital"></textarea>
        <b-button class="saveButton is-primary" @click="saveKenshin_hospital" :disabled="!active.kenshin_hospital">保存</b-button>
      </div>
      <div class="labelTitle lable">
        企業検診確認事項(宿泊施設)<a style="float:right;" @click="isShowKenshin_accommodation=!isShowKenshin_accommodation"><b-icon v-if="isShowKenshin_accommodation" icon="minus-box" type="is-white"/><b-icon v-if="!isShowKenshin_accommodation" icon="chevron-down-box" type="is-white"/></a>
      </div>
      <div v-if="isShowKenshin_accommodation" class="containtsArea">
        <textarea class="agreementTextArea noresize" v-model="agreement.kenshin_accommodation" :disabled="!active.kenshin_accommodation"></textarea>
        <b-button class="saveButton is-primary" @click="saveKenshin_accommodation" :disabled="!active.kenshin_accommodation">保存</b-button>
      </div>
      <div class="labelTitle lable">
        ケア オーケストレーター確認事項<a style="float:right;" @click="isShowCO=!isShowCO"><b-icon v-if="isShowCO" icon="minus-box" type="is-white"/><b-icon v-if="!isShowCO" icon="chevron-down-box" type="is-white"/></a>
      </div>
      <div v-if="isShowCO" class="containtsArea">
        <textarea class="agreementTextArea noresize" v-model="agreement.co" :disabled="!active.co"></textarea>
        <div>
          <b-button class="saveButton is-primary" @click="saveCo" :disabled="!active.co">保存</b-button>
          <b-field class="file pdfButton">
            <b-upload v-model="coPdf" @input="coUpload" :disabled="!active.co">
              <a class="button is-primary">
                <span>PDFアップロード</span>
              </a>
            </b-upload>
          </b-field>
        </div>
      </div>
      <div class="labelTitle lable">
        CPAP確認事項<a style="float:right;" @click="isShowCpap=!isShowCpap"><b-icon v-if="isShowCpap" icon="minus-box" type="is-white"/><b-icon v-if="!isShowCpap" icon="chevron-down-box" type="is-white"/></a>
      </div>
      <div v-if="isShowCpap" class="containtsArea">
        <textarea class="agreementTextArea noresize" v-model="agreement.cpap" :disabled="!active.cpap"></textarea>
        <div>
          <b-button class="saveButton is-primary" @click="saveCpap" :disabled="!active.cpap">保存</b-button>
          <b-field class="file pdfButton">
            <b-upload v-model="cpapPdf" @input="cpapUpload" :disabled="!active.cpap">
              <a class="button is-primary">
                <span>PDFアップロード</span>
              </a>
            </b-upload>
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/philips/master/MasterMaintenanceBar";
import {consentStatement} from "@/components/mock/base/const.js";
export default {
  name: "AgreementEdit",
  methods: {
    saveTerms: function(){
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.setConsentStatementPOST({
            body: {
              type: _this.statement.registPage,
              contents: _this.agreement.terms
            }
          });
        },
        this.successSave,
        this.errorSave,
      );
    },
    termsUpload: function() {
      var _this = this;
      this.uploadApiCall(
        function(client){
          return client.apis.apiCommon.uploadConsentStatementPOST({
              upfile: _this.termsPdf,
              type: _this.statement.registPage
          })
        },
        this.successSave,
        this.errorSave,
      ); 
    },
    saveHst_hospital: function(){
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.setConsentStatementPOST({
            body: {
              type: _this.statement.hst_hospital,
              contents: _this.agreement.hst_hospital
            }
          });
        },
        this.successSave,
        this.errorSave,
      );
    },
    saveHst_dealer: function(){
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.setConsentStatementPOST({
            body: {
              type: _this.statement.hts_dealer,
              contents: _this.agreement.hst_dealer
            }
          });
        },
        this.successSave,
        this.errorSave,
      );
    },
    saveHolter_hospital: function(){
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.setConsentStatementPOST({
            body: {
              type: _this.statement.holter_hospital,
              contents: _this.agreement.holter_hospital
            }
          });
        },
        this.successSave,
        this.errorSave,
      );
    },
    saveHolter_dealer: function(){
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.setConsentStatementPOST({
            body: {
              type: _this.statement.holter_dealer,
              contents: _this.agreement.holter_dealer
            }
          });
        },
        this.successSave,
        this.errorSave,
      );
    },
    savePsg_hospital: function() {
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.setConsentStatementPOST({
            body: {
              type: _this.statement.psg_hospital,
              contents: _this.agreement.psg_hospital
            }
          });
        },
        this.successSave,
        this.errorSave,
      );
    },
    savePsg_dealer: function(){
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.setConsentStatementPOST({
            body: {
              type: _this.statement.psg_dealer,
              contents: _this.agreement.psg_dealer
            }
          });
        },
        this.successSave,
        this.errorSave,
      );
    },
    saveHolterAnalysis_hospital: function(){
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.setConsentStatementPOST({
            body: {
              type: _this.statement.holter_analysis_hospital,
              contents: _this.agreement.holter_analysis_hospital
            }
          });
        },
        this.successSave,
        this.errorSave,
      );
    },
    saveHolterAnalysis_dealer: function(){
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.setConsentStatementPOST({
            body: {
              type: _this.statement.holter_analysis_dealer,
              contents: _this.agreement.holter_analysis_dealer
            }
          });
        },
        this.successSave,
        this.errorSave,
      );
    },
    saveKenshin_corp: function() {
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.setConsentStatementPOST({
            body: {
              type: _this.statement.kenshin_corp,
              contents: _this.agreement.kenshin_corp
            }
          });
        },
        this.successSave,
        this.errorSave,
      );      
    },
    saveKenshin_dealer: function() {
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.setConsentStatementPOST({
            body: {
              type: _this.statement.kenshin_dealer,
              contents: _this.agreement.kenshin_dealer
            }
          });
        },
        this.successSave,
        this.errorSave,
      );
    },
    saveKenshin_hospital: function() {
      var _this = this;
      this.apiCall(
        function(client){

          return client.apis.apiCommon.setConsentStatementPOST({
            body: {
              type: _this.statement.kenshin_hospital,
              contents: _this.agreement.kenshin_hospital
            }
          });
        },
        this.successSave,
        this.errorSave,
      );      
    },
    saveKenshin_accommodation: function() {
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.setConsentStatementPOST({
            body: {
              type: _this.statement.kenshin_accommodations,
              contents: _this.agreement.kenshin_accommodation
            }
          });
        },
        this.successSave,
        this.errorSave,
      );
    },
    saveCo: function(){
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.setConsentStatementPOST({
            body: {
              type: _this.statement.care_orchestrator,
              contents: _this.agreement.co
            }
          });
        },
        this.successSave,
        this.errorSave,
      );
    },
    saveCpap: function(){
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.setConsentStatementPOST({
            body: {
              type: _this.statement.cpap,
              contents: _this.agreement.cpap
            }
          });
        },
        this.successSave,
        this.errorSave,
      );
    },
    coUpload: function(){
      var _this = this;
      this.uploadApiCall(
        function(client){
          return client.apis.apiCommon.uploadConsentStatementPOST({
              upfile: _this.coPdf,
              type: _this.statement.care_orchestrator
          })
        },
        this.successSave,
        this.errorSave,
      );
    },
    cpapUpload: function(){
      var _this = this;
      this.uploadApiCall(
        function(client){
          return client.apis.apiCommon.uploadConsentStatementPOST({
              upfile: _this.cpapPdf,
              type: _this.statement.cpap
          })
        },
        this.successSave,
        this.errorSave,
      );
    },
    successSave: function(result){
      this.showSuccess(result);
      this.termsPdf = null;
      this.coPdf = null;
      this.cpapPdf = null;
    },
    errorSave: function(result){
      this.showErrorMessage(result);
      this.termsPdf = null;
      this.coPdf = null;
      this.cpapPdf = null;
    },
  },
  data() {
    return {
      statement:consentStatement,
      agreement:{
        terms: "",
        hst_hospital: "",
        hst_dealer: "",
        holter_hospital: "",
        holter_dealer: "",
        psg_hospital: "",
        psg_dealer: "",
        holter_analysis_hospital: "",
        holter_analysis_dealer: "",
        kenshin_corp: "",
        kenshin_dealer: "",
        kenshin_hospital: "",
        kenshin_accommodation: "",
        co: "",
        cpap:"",
      },
      isShowTerms: true,
      isShowHst_hospital: true,
      isShowHst_dealer: true,
      isShowHolter_hospital: true,
      isShowHolter_dealer: true,
      isShowPsg_hospital: true,
      isShowPsg_dealer: true,
      isShowHolterAnalysis_hospital: true,
      isShowHolterAnalysis_dealer: true,
      isShowKenshin_corp: true,
      isShowKenshin_dealer: true,
      isShowKenshin_hospital: true,
      isShowKenshin_accommodation: true,
      isShowCO: true,
      isShowCpap: true,
      active:{
        terms: false,
        hst_hospital: false,
        hst_dealer: false,
        psg_hospital: false,
        psg_dealer: false,
        kenshin_corp: false,
        kenshin_dealer: false,
        kenshin_hospital: false,
        kenshin_accommodation: false,
        co: false,
        cpap:false,
      },
      termsPdf:null,
      coPdf:null,
      cpapPdf:null
    };
  },
  filters: {},
  components: {
    masterNavi: naviBar,
  },
  mounted: async function(){
    var params = [
      {type:this.statement.registPage , field: "terms"},
      {type:this.statement.hst_hospital , field: "hst_hospital"},
      {type:this.statement.hts_dealer , field: "hst_dealer"},
      {type:this.statement.holter_hospital , field: "holter_hospital"},
      {type:this.statement.holter_dealer , field: "holter_dealer"},
      {type:this.statement.psg_hospital , field: "psg_hospital"},
      {type:this.statement.psg_dealer , field: "psg_dealer"},
      {type:this.statement.holter_analysis_hospital , field: "holter_analysis_hospital"},
      {type:this.statement.holter_analysis_dealer , field: "holter_analysis_dealer"},
      {type:this.statement.kenshin_corp , field: "kenshin_corp"},
      {type:this.statement.kenshin_dealer , field: "kenshin_dealer"},
      {type:this.statement.kenshin_hospital , field: "kenshin_hospital"},
      {type:this.statement.kenshin_accommodations , field: "kenshin_accommodation"},
      {type:this.statement.care_orchestrator , field: "co"},
      {type:this.statement.cpap , field: "cpap"},
    ]
    for(let param of params){
      await this.$store.dispatch("getConsentStatement", {
          type: param.type,
      }).then(result => {
        console.log(result);
        if(result != null && result.status === 200 ) {
            this.agreement[param.field] = result.body.contents;
        }
      }).catch(error => {
          this.agreement[param.field] ="規約を取得できませんでした。"
      });
      this.active[param.field] = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.containtsArea {
  margin-top:10px;
  height: 500px;
}
.agreementTextArea {
  float: left;
  width: 1000px;
  height: 500px;
}
.pdfButton,
.saveButton {
  float: left;
  margin-left:10px;
}
.pdfButton {
  margin-top:20px;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/master/agreement/AgreementEdit.vue